import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CTASection({
  title = "Ready to Explore Suitable Loan Options?",
  subtitle = "Submit your enquiry and our team will guide you through suitable options offered by banks and financial institutions.",
}) {
  return (
    <section className="px-4 sm:px-6 lg:px-8 py-20 lg:py-28" data-testid="cta-section">
      <Reveal>
        <div className="max-w-5xl mx-auto relative overflow-hidden rounded-3xl border border-[rgba(212,175,55,0.25)] bg-gradient-to-b from-[#18181E] to-[#0F0F13] px-6 py-14 sm:p-16 text-center">
          <div
            className="absolute -top-24 left-1/2 -translate-x-1/2 w-[520px] h-[280px] rounded-full pointer-events-none"
            style={{ background: "radial-gradient(ellipse, rgba(212,175,55,0.16) 0%, transparent 65%)" }}
          />
          <p className="caption-gold mb-4 relative">Begin Your Journey</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white relative">
            {title}
          </h2>
          <p className="mt-4 max-w-xl mx-auto text-sm sm:text-base text-[#A1A1AA] leading-relaxed relative">{subtitle}</p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4 relative">
            <Link
              to="/contact"
              data-testid="cta-get-loan-assistance"
              className="btn-gold inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm"
            >
              <span className="relative z-10 flex items-center gap-2">
                Get Loan Assistance <ArrowRight size={16} />
              </span>
            </Link>
            <Link
              to="/contact"
              data-testid="cta-contact-us"
              className="btn-outline-gold inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm"
            >
              <Mail size={16} /> Contact Us
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
